function cstm_main_coll_prd_grid_init() {
  console.log('cstm_main_coll_prd_grid: Starting initialization...');
  
  // Wait for DOM to be ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      cstm_main_coll_prd_grid_setup();
    });
  } else {
    cstm_main_coll_prd_grid_setup();
  }
  
  function cstm_main_coll_prd_grid_setup() {
    console.log('cstm_main_coll_prd_grid: Setting up...');
    // Initial setup
    cstm_main_coll_prd_grid_initializeAll();
    
    // Set up observer for dynamic content
    cstm_main_coll_prd_grid_setupObserver();
    
    // Fallback: check every 500ms for 10 seconds
    cstm_main_coll_prd_grid_startFallbackCheck();
  }
  
  function cstm_main_coll_prd_grid_initializeAll() {
    const sections = document.querySelectorAll('.cstm_main_coll_prd_grid');
    console.log(`cstm_main_coll_prd_grid: Found ${sections.length} sections`);
    
    sections.forEach(section => {
      cstm_main_coll_prd_grid_initializeSection(section);
    });
  }
  
  function cstm_main_coll_prd_grid_initializeSection(section) {
    // Look for variant selects within the product cards inside the section
    const selects = section.querySelectorAll('.variant-select');
    console.log(`cstm_main_coll_prd_grid: Found ${selects.length} variant selects in section`);
    
    selects.forEach(select => {
      if (select.hasAttribute('data-cstm-main-coll-init')) {
        console.log('cstm_main_coll_prd_grid: Select already initialized, skipping');
        return;
      }
      
      console.log('cstm_main_coll_prd_grid: Initializing variant select:', select);
      select.setAttribute('data-cstm-main-coll-init', 'true');
      select.addEventListener('change', cstm_main_coll_prd_grid_handleVariantChange);
      
      // Update price on page load for the initially selected variant
      cstm_main_coll_prd_grid_updatePriceOnLoad(select);
    });
  }
  
  function cstm_main_coll_prd_grid_updatePriceOnLoad(selectElement) {
    console.log('cstm_main_coll_prd_grid: Updating price on page load for variant:', selectElement.value);
    
    const productCard = selectElement.closest('.card-wrapper, .product-card-wrapper');
    if (!productCard) {
      console.error('cstm_main_coll_prd_grid: Product card not found');
      return;
    }
    
    const priceContainer = productCard.querySelector('.price');
    if (!priceContainer) {
      console.error('cstm_main_coll_prd_grid: Price container not found');
      return;
    }
    
    // Store the original content for comparison
    const originalContent = priceContainer.innerHTML;
    
    const productId = selectElement.dataset.productId;
    const variantId = selectElement.value;
    
    if (!productId) {
      console.error('cstm_main_coll_prd_grid: Could not get product ID');
      return;
    }
    
    console.log(`cstm_main_coll_prd_grid: Fetching price on load for product ${productId}, variant ${variantId}`);
    
    // Get product data and update price
    cstm_main_coll_prd_grid_getProductData(productId, variantId, priceContainer, originalContent, true);
  }
  
  function cstm_main_coll_prd_grid_handleVariantChange(event) {
    console.log('cstm_main_coll_prd_grid: Variant changed');
    cstm_main_coll_prd_grid_updatePriceOnChange(event.target);
  }
  
  function cstm_main_coll_prd_grid_updatePriceOnChange(selectElement) {
    console.log('cstm_main_coll_prd_grid: Updating price on variant change for:', selectElement.value);
    
    const productCard = selectElement.closest('.card-wrapper, .product-card-wrapper');
    if (!productCard) {
      console.error('cstm_main_coll_prd_grid: Product card not found');
      return;
    }
    
    const priceContainer = productCard.querySelector('.price');
    if (!priceContainer) {
      console.error('cstm_main_coll_prd_grid: Price container not found');
      return;
    }
    
    const originalContent = priceContainer.innerHTML;
    priceContainer.innerHTML = '<div class="cstm_main_coll_prd_grid-price-loading">Loading...</div>';
    
    const productId = selectElement.dataset.productId;
    const variantId = selectElement.value;
    
    if (!productId) {
      console.error('cstm_main_coll_prd_grid: Could not get product ID');
      priceContainer.innerHTML = originalContent;
      return;
    }
    
    console.log(`cstm_main_coll_prd_grid: Fetching price on change for product ${productId}, variant ${variantId}`);
    
    // Method 1: Try to get product data and find variant
    cstm_main_coll_prd_grid_getProductData(productId, variantId, priceContainer, originalContent, false);
  }
  
  function cstm_main_coll_prd_grid_getProductData(productId, variantId, priceContainer, originalContent, isPageLoad = false) {
    // Try to fetch product data from Shopify's JSON API
    fetch(`/products/${cstm_main_coll_prd_grid_getProductHandleFromId(productId)}.js`)
      .then(response => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then(product => {
        console.log('cstm_main_coll_prd_grid: Received product data:', product);
        
        // Find the specific variant in the product data
        const variant = product.variants.find(v => v.id == variantId);
        if (variant) {
          console.log('cstm_main_coll_prd_grid: Found variant:', variant);
          
          // Convert cents to dollars for display
          const priceInDollars = variant.price / 100;
          const comparePriceInDollars = variant.compare_at_price ? variant.compare_at_price / 100 : null;
          
          console.log('cstm_main_coll_prd_grid: Prices in dollars:', { 
            price: priceInDollars, 
            comparePrice: comparePriceInDollars 
          });
          
          // Only update if the price is different from current display (for page load)
          if (isPageLoad) {
            cstm_main_coll_prd_grid_updatePriceDisplayIfNeeded(priceContainer, priceInDollars, comparePriceInDollars, originalContent);
          } else {
            cstm_main_coll_prd_grid_updatePriceDisplay(priceContainer, priceInDollars, comparePriceInDollars);
          }
        } else {
          throw new Error('Variant not found in product data');
        }
      })
      .catch(error => {
        console.error('cstm_main_coll_prd_grid: Product JSON method failed:', error);
        if (!isPageLoad) {
          // Only show error fallback for change events, not page load
          cstm_main_coll_prd_grid_trySectionsAPI(productId, variantId, priceContainer, originalContent);
        }
      });
  }
  
  function cstm_main_coll_prd_grid_updatePriceDisplayIfNeeded(priceContainer, price, comparePrice, originalContent) {
    // For page load, only update if the price is different from what's currently displayed
    const currentPriceText = priceContainer.querySelector('.price-item--last, .price-item--regular')?.textContent || '';
    const newPriceText = cstm_main_coll_prd_grid_formatMoney(price);
    
    console.log('cstm_main_coll_prd_grid: Comparing prices - current:', currentPriceText, 'new:', newPriceText);
    
    // If prices are different, update the display
    if (currentPriceText.trim() !== newPriceText.trim()) {
      console.log('cstm_main_coll_prd_grid: Prices differ, updating display');
      cstm_main_coll_prd_grid_updatePriceDisplay(priceContainer, price, comparePrice);
    } else {
      console.log('cstm_main_coll_prd_grid: Prices are the same, no update needed');
    }
  }
  
  function cstm_main_coll_prd_grid_updatePriceDisplay(priceContainer, price, comparePrice) {
    console.log('cstm_main_coll_prd_grid: Updating price display with dollars:', { price, comparePrice });
    
    const productCard = priceContainer.closest('.card-wrapper, .product-card-wrapper');
    if (!productCard) {
      console.error('cstm_main_coll_prd_grid: Product card not found for updating prices');
      return;
    }
    
    // Format the prices (now in dollars)
    const formattedPrice = cstm_main_coll_prd_grid_formatMoney(price);
    const formattedComparePrice = comparePrice ? cstm_main_coll_prd_grid_formatMoney(comparePrice) : null;
    
    console.log('cstm_main_coll_prd_grid: Formatted prices:', { formattedPrice, formattedComparePrice });
    
    // Update main price display
    if (formattedComparePrice && formattedComparePrice !== formattedPrice) {
      // Product is on sale
      priceContainer.innerHTML = `
        <div class="price__container">
          <div class="price__sale">
            <span class="visually-hidden visually-hidden--inline">Regular price</span>
            <span>
              <s class="price-item price-item--regular">${formattedComparePrice}</s>
            </span>
            <span class="visually-hidden visually-hidden--inline">Sale price</span>
            <span class="price-item price-item--sale price-item--last">${formattedPrice}</span>
          </div>
        </div>
      `;
    } else {
      // Regular price
      priceContainer.innerHTML = `
        <div class="price__container">
          <div class="price__regular">
            <span class="visually-hidden visually-hidden--inline">Regular price</span>
            <span class="price-item price-item--regular">${formattedPrice}</span>
          </div>
        </div>
      `;
    }
    
    // ALSO UPDATE THE ADD TO CART BUTTON PRICE
    const addToCartButton = productCard.querySelector('.quick-add__submit .product-prices');
    if (addToCartButton) {
      addToCartButton.textContent = formattedPrice;
      console.log('cstm_main_coll_prd_grid: Updated add to cart button price to:', formattedPrice);
    }
    
    // ALSO UPDATE THE HIDDEN VARIANT ID IN THE FORM
    const variantIdInput = productCard.querySelector('.product-variant-id');
    if (variantIdInput) {
      const selectElement = productCard.querySelector('.variant-select');
      if (selectElement) {
        variantIdInput.value = selectElement.value;
        console.log('cstm_main_coll_prd_grid: Updated variant ID in form to:', selectElement.value);
      }
    }
    
    console.log('cstm_main_coll_prd_grid: Price updated successfully');
  }
  
  // ... rest of the functions remain the same (formatMoney, getProductHandleFromId, getProductHandle, setupObserver, startFallbackCheck)
  
  function cstm_main_coll_prd_grid_formatMoney(amount) {
    console.log('cstm_main_coll_prd_grid: Formatting dollar amount:', amount);
    
    const formatted = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD'
    }).format(amount);
    
    console.log('cstm_main_coll_prd_grid: Formatted amount:', formatted);
    return formatted;
  }
  
  function cstm_main_coll_prd_grid_getProductHandleFromId(productId) {
    // This is a helper function - you might need to adjust this based on your theme
    // For now, we'll try to get the handle from the product card
    const productCard = document.querySelector(`[data-product-id="${productId}"]`)?.closest('.card-wrapper, .product-card-wrapper');
    if (productCard) {
      return cstm_main_coll_prd_grid_getProductHandle(productCard);
    }
    return '';
  }
  
  function cstm_main_coll_prd_grid_getProductHandle(productCard) {
    const link = productCard.querySelector('a[href*="/products/"]');
    if (!link) {
      console.error('cstm_main_coll_prd_grid: Product link not found');
      return '';
    }
    
    const href = link.getAttribute('href');
    const match = href.match(/\/products\/([^?]+)/);
    const handle = match ? match[1] : '';
    
    console.log('cstm_main_coll_prd_grid: Extracted product handle:', handle);
    return handle;
  }
  
  function cstm_main_coll_prd_grid_setupObserver() {
    console.log('cstm_main_coll_prd_grid: Setting up mutation observer');
    
    const observer = new MutationObserver(function(mutations) {
      let foundNewContent = false;
      
      mutations.forEach(function(mutation) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1) {
            // Check if the added node is our section or contains it
            if (node.classList && node.classList.contains('cstm_main_coll_prd_grid')) {
              foundNewContent = true;
            } else if (node.querySelector && node.querySelector('.cstm_main_coll_prd_grid')) {
              foundNewContent = true;
            }
            
            // Also check if variant selects were added directly
            if (node.querySelector && node.querySelector('.variant-select')) {
              foundNewContent = true;
            }
          }
        });
      });
      
      if (foundNewContent) {
        console.log('cstm_main_coll_prd_grid: New content detected, reinitializing...');
        setTimeout(() => {
          cstm_main_coll_prd_grid_initializeAll();
        }, 300);
      }
    });
    
    // Wait a bit before starting observer
    setTimeout(() => {
      const target = document.body || document.documentElement;
      if (target) {
        observer.observe(target, { childList: true, subtree: true });
        console.log('cstm_main_coll_prd_grid: Mutation observer started');
      } else {
        console.error('cstm_main_coll_prd_grid: No target found for observer');
      }
    }, 100);
  }
  
  function cstm_main_coll_prd_grid_startFallbackCheck() {
    console.log('cstm_main_coll_prd_grid: Starting fallback checks');
    
    let attempts = 0;
    const maxAttempts = 20; // 10 seconds total
    
    const interval = setInterval(() => {
      const sections = document.querySelectorAll('.cstm_main_coll_prd_grid');
      let foundNew = false;
      
      sections.forEach(section => {
        if (!section.hasAttribute('data-cstm-main-coll-checked')) {
          section.setAttribute('data-cstm-main-coll-checked', 'true');
          console.log('cstm_main_coll_prd_grid: Fallback check found new section');
          cstm_main_coll_prd_grid_initializeSection(section);
          foundNew = true;
        }
        
        // Also check for new variant selects in existing sections
        const newSelects = section.querySelectorAll('.variant-select:not([data-cstm-main-coll-init])');
        if (newSelects.length > 0) {
          console.log(`cstm_main_coll_prd_grid: Fallback check found ${newSelects.length} new selects`);
          newSelects.forEach(select => {
            select.setAttribute('data-cstm-main-coll-init', 'true');
            select.addEventListener('change', cstm_main_coll_prd_grid_handleVariantChange);
            // Also update price on load for newly found selects
            cstm_main_coll_prd_grid_updatePriceOnLoad(select);
          });
          foundNew = true;
        }
      });
      
      if (foundNew) {
        console.log('cstm_main_coll_prd_grid: Fallback check processed new elements');
      }
      
      attempts++;
      if (attempts >= maxAttempts) {
        console.log('cstm_main_coll_prd_grid: Fallback checks completed');
        clearInterval(interval);
      }
    }, 500);
  }
}

// Safe initialization - only run if the element exists
if (typeof document !== 'undefined' && document.querySelector('.cstm_main_coll_prd_grid')) {
  cstm_main_coll_prd_grid_init();
} else {
  console.log('cstm_main_coll_prd_grid: Element not found or document not available');
  // Optional: You can also set up a check to run when the element appears later
  if (typeof window !== 'undefined') {
    const checkElementInterval = setInterval(() => {
      if (document.querySelector('.cstm_main_coll_prd_grid')) {
        console.log('cstm_main_coll_prd_grid: Element found later, initializing...');
        cstm_main_coll_prd_grid_init();
        clearInterval(checkElementInterval);
      }
    }, 500);
    
    // Stop checking after 10 seconds
    setTimeout(() => {
      clearInterval(checkElementInterval);
    }, 10000);
  }
}